document.addEventListener("DOMContentLoaded", function () {
    function setClass(els, className, fnName) {
      for (var i = 0; i < els.length; i++) {
        els[i].classList[fnName](className);
      }
    }
  
    if (document.getElementsByClassName("hd-content__faq--wrap").length >= 1) {
      var acc = document.getElementsByClassName("hd-content__faq--wrap__question");
      var panel = document.getElementsByClassName("hd-content__faq--wrap__answer");
  
      for (var i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function (e) {
      var parentDiv = this.closest(".hd-content__faq--wrap");
      if (parentDiv) {
        parentDiv.classList.toggle("hd-content__faq--wrap__active");
      }
    });
  }
    }
  });